import React from 'react';
import { Box, Container, Typography, IconButton, Link as MuiLink, useTheme, useMediaQuery, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/big-logo.svg';
import instagram from '../../assets/images/instagram.png';
import linkedin from '../../assets/images/linkedin.png';

const StyledLegalLink = styled(Link)(({ theme }) => ({
  color: 'rgba(154, 166, 167, 1)',
  textDecoration: 'none',
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
  '&:hover': {
    color: '#fff',
  },
}));

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const legalLinks = [
    {
      title: 'KVKK ve Kişisel Verilerin Korunması',
      href: '/legal/kvkk',
    },
    {
      title: 'Mesafeli Satış Sözleşmesi',
      href: '/legal/satis',
    },
    {
      title: 'Gizlilik Politikası',
      href: '/legal/gizlilik',
    },
    {
      title: 'Çerez Politikası',
      href: '/legal/cerez',
    },
    {
      title: 'İptal ve İade Koşulları',
      href: '/legal/iptal-iade',
    }
  ]
  return (
    <Box sx={{ background: 'rgba(2, 36, 38, 1)', color: '#fff', py: 2 }}>
      <Container
        sx={{
          py: { xs: 2, md: 4 },
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: { xs: 4, md: 2 },
          }}
        >
          <Box
            sx={{
              maxWidth: '175px',
            }}
          >
            <Box
              component='img'
              src={logo}
              alt='logo'
              sx={{ width: '100px' }}
            />
            <Typography
              sx={{
                fontSize: '14px',
                color: '#fff',
              }}
            >
              Kuyumculukta yeni nesil ödeme devri!
            </Typography>
          </Box>
          <Box sx={{ mt: { xs: 2, md: 0 } }}>
            <Typography
              sx={{
                fontSize: { xs: '15px', md: '16px' },
                fontWeight: 700,
                color: '#fff',
              }}
            >
              İletişim
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '13px', md: '14px' },
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              Yenibosna Merkez Mah. 29 Ekim Cad.
              <br />
              B2 No: 9 İç Kapı No: 103
              <br />
              Bahçelievler/İstanbul
              <br />
              info@refinera.com.tr
            </Typography>
          </Box>
          <Box sx={{ mt: { xs: 2, md: 0 } }}>
            <Typography
              sx={{
                fontSize: { xs: '15px', md: '16px' },
                fontWeight: 700,
                color: '#fff',
              }}
            >
              Bizi Takip Edin
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '13px', md: '14px' },
                color: 'rgba(255, 255, 255, 1)',
              }}
            >
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <IconButton href="https://www.instagram.com/" target="_blank" sx={{ p: 0 }}>
                  <Box component='img' src={instagram} alt='instagram' sx={{ width: 18, height: 18 }} />
                </IconButton>
                <IconButton href="https://www.linkedin.com/" target="_blank" sx={{ p: 0 }}>
                  <Box component='img' src={linkedin} alt='linkedin' sx={{ width: 18, height: 18 }} />
                </IconButton>
              </Box>
            </Typography>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Box sx={{
          display: 'flex',
          gap: { xs: 1.5, md: 2 },
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          mt: 2,
          pb: 2,
          px: { xs: 1, md: 0 },
        }}>
          {legalLinks.map((link) => (
            <StyledLegalLink 
              to={link.href} 
              key={link.title}
            >
              {link.title}
            </StyledLegalLink>
          ))}
        </Box>
      </Container>
    </Box>
  );
} 